<!--导航菜单栏-->
<template>
    <el-menu
        :mode="mode"
        :default-active="defaultActive"
        class="el-menu-vertical-demo ml-n9 mt-3"
        unique-opened
        router
        :background-color="theme.navigationDrawerBgColor"
        :text-color="theme.navigationDrawerFontColor"
        :active-text-color="theme.activeDrawerFontColor"
        style="border:none;"
    >
        <el-menu-item
            index="/"
            :class="itemTopClass"
            style="height:6vh;display: flex;align-items: center;"
        >
            <template slot="title">
                <i
                    class="el-icon-s-home"
                    :style="{
                        color:
                            defaultActive == '/'
                                ? theme.activeDrawerFontColor
                                : theme.navigationDrawerFontColor,
                        fontSize: '1.3em',
                        paddingRight: '0.3em',
                        paddingLeft: '0.3em',
                    }"
                ></i>
                <span>
                    首页
                </span>
            </template>
        </el-menu-item>

        <el-submenu v-if="user.type !== 5" index="/station">
            <template slot="title">
                <i
                    class="iconfont icon-chongdianzhandian"
                    :style="{
                        color:
                            defaultActive == '/station/operating' ||
                            defaultActive == '/station/management'
                                ? theme.activeDrawerFontColor
                                : theme.navigationDrawerFontColor,
                        fontSize: '1.3em',
                        paddingLeft: '0.1em',
                    }"
                ></i>
                <span
                    :style="{
                        color:
                            defaultActive == '/station/operating' ||
                            defaultActive == '/station/management'
                                ? theme.activeDrawerFontColor
                                : theme.navigationDrawerFontColor,
                        paddingLeft: '0.4em',
                    }"
                >
                    站点
                </span>
            </template>
            <el-menu-item
                v-for="(item, index) in station"
                :key="index"
                :class="groupTopClass"
                :index="item.path"
                style="height:6vh;display: flex;align-items: center;"
            >
                <i :class="item.icon"></i>
                {{ item.text }}
            </el-menu-item>
        </el-submenu>

        <el-submenu v-if="user.type !== 5" index="/devices" >
            <template slot="title">
                <i
                    class="iconfont icon-shixian"
                    :style="{
                        color:
                            defaultActive == '/devices/pile' ||
                            defaultActive == '/devices/gun' ||
                            defaultActive == '/devices/details'
                                ? theme.activeDrawerFontColor
                                : theme.navigationDrawerFontColor,
                        fontSize: '1.3em',
                        paddingLeft: '0.1em',
                    }"
                ></i>
                <span
                    :style="{
                        color:
                            defaultActive == '/devices/pile' ||
                            defaultActive == '/devices/gun' ||
                            defaultActive == '/devices/details'
                                ? theme.activeDrawerFontColor
                                : theme.navigationDrawerFontColor,
                        paddingLeft: '0.4em',
                    }"
                >
                    设备
                </span>
            </template>
            <el-menu-item
                v-for="(item, index) in devices"
                :key="index"
                :class="groupTopClass"
                :index="item.path"
                style="height:6vh;display: flex;align-items: center;"
            >
                <i :class="item.icon"></i>
                {{ item.text }}
            </el-menu-item>
        </el-submenu>

        <el-submenu index="/order">
            <template slot="title">
                <i
                    class="el-icon-tickets"
                    :style="{
                        color:
                            defaultActive == '/order/operating' ||
                            defaultActive == '/order/list' ||
                            defaultActive == '/order/details'
                                ? theme.activeDrawerFontColor
                                : theme.navigationDrawerFontColor,
                        fontSize: '1.3em',
                    }"
                ></i>
                <span
                    :style="{
                        color:
                            defaultActive == '/order/operating' ||
                            defaultActive == '/order/list' ||
                            defaultActive == '/order/details'
                                ? theme.activeDrawerFontColor
                                : theme.navigationDrawerFontColor,
                    }"
                >
                    订单
                </span>
            </template>
            <el-menu-item
                v-for="(item, index) in order"
                :key="index"
                :class="groupTopClass"
                :index="item.path"
                style="height:6vh;display: flex;align-items: center;"
            >
                <i :class="item.icon"></i>
                {{ item.text }}
            </el-menu-item>
        </el-submenu>

        <el-submenu v-if="user.type !== 5" index="/coupons">
            <template slot="title">
                <i
                    class="el-icon-s-ticket"
                    :style="{
                        color:
                            defaultActive == '/coupons/template' ||
                            defaultActive == '/coupons/userCoupons' ||
                            defaultActive == '/coupons/activity'
                                ? theme.activeDrawerFontColor
                                : theme.navigationDrawerFontColor,
                        fontSize: '1.3em',
                    }"
                ></i>
                <span
                    :style="{
                        color:
                            defaultActive == '/coupons/template' ||
                            defaultActive == '/coupons/userCoupons' ||
                            defaultActive == '/coupons/activity'
                                ? theme.activeDrawerFontColor
                                : theme.navigationDrawerFontColor,
                    }"
                >
                    优惠券
                </span>
            </template>
            <el-menu-item
                v-for="(item, index) in coupons"
                :key="index"
                :class="groupTopClass"
                :index="item.path"
                style="height:6vh;display: flex;align-items: center;"
            >
                <i :class="item.icon"></i>
                {{ item.text }}
            </el-menu-item>
        </el-submenu>

        <el-menu-item v-if="user.type !== 5" index="/ic" :class="itemTopClass">
            <template slot="title">
                <i
                    class="el-icon-bank-card"
                    :style="{
                        color:
                            defaultActive == '/ic'
                                ? theme.activeDrawerFontColor
                                : theme.navigationDrawerFontColor,
                        fontSize: '1.3em',
                        paddingLeft: '0.3em',
                    }"
                ></i>
                <span style="padding-left:0.3em">
                    IC卡
                </span>
            </template>
        </el-menu-item>

       <!-- <el-menu-item index="/user" :class="itemTopClass">
            <template slot="title">
                <i
                    class="el-icon-user"
                    :style="{
                        color:
                            defaultActive == '/user'
                                ? theme.activeDrawerFontColor
                                : theme.navigationDrawerFontColor,
                        fontSize: '1.3em',
                        paddingLeft: '0.3em',
                    }"
                ></i>
                <span style="padding-left:0.3em">
                    用户
                </span>
            </template>
        </el-menu-item> -->
        <el-menu-item v-if="role === 0 && user.type !== 5" index="/contact" :class="itemTopClass">
            <template slot="title">
                <i
                    class="el-icon-share"
                    :style="{
                        color:
                            defaultActive == '/contact'
                                ? theme.activeDrawerFontColor
                                : theme.navigationDrawerFontColor,
                        fontSize: '1.3em',
                        paddingLeft: '0.3em',
                    }"
                ></i>
                <span style="padding-left:0.3em">
                    互联互通
                </span>
            </template>
        </el-menu-item>
		
		<el-menu-item v-if="user.type !== 5" index="/systemParams" :class="itemTopClass">
		    <template slot="title">
		        <i
		            class="el-icon-s-platform"
		            :style="{
		                color:
		                    defaultActive == '/systemParams'
		                        ? theme.activeDrawerFontColor
		                        : theme.navigationDrawerFontColor,
		                fontSize: '1.3em',
		                paddingLeft: '0.3em',
		            }"
		        ></i>
		        <span style="padding-left:0.3em">
		            系统参数
		        </span>
		    </template>
		</el-menu-item>
		
        <el-menu-item v-if="user.type !== 5" index="/set" :class="itemTopClass">
            <template slot="title">
                <i
                    class="el-icon-setting"
                    :style="{
                        color:
                            defaultActive == '/set'
                                ? theme.activeDrawerFontColor
                                : theme.navigationDrawerFontColor,
                        fontSize: '1.6em',
                        paddingLeft: '0.3em',
                    }"
                ></i>
                <span style="padding-left:0.3em">
                    设置
                </span>
            </template>
        </el-menu-item>
    </el-menu>
</template>
<script>
import { mapState } from "vuex";
export default {
    data() {
        return {};
    },
    props: {
        mode: null,
        itemTopClass: null,
        groupTopClass: null,
    },
    computed: {
        ...mapState(["theme", "navigationMode", "user","role"]),
        /*获取当前页面路由*/
        defaultActive() {
            return this.$route.path;
        },
        /*站点下拉路径*/
        station() {
            // if(user.role==0) { icon-yunying
            return [
                {
                    icon: "iconfont icon-yunying",
                    path: "/station/operating",
                    text: "运营",
                },
                {
                    icon: "el-icon-set-up",
                    path: "/station/management",
                    text: "管理",
                },
            ];
            // }
        },
        /*订单下拉路径*/
        order() {
            // if(user.role==0) {
            return [
                {
                    icon: "iconfont icon-yunying",
                    path: "/order/operating",
                    text: "运营",
                },
                {
                    icon: "el-icon-notebook-1",
                    path: "/order/list",
                    text: "详情",
                },
            ];
            // }
        },
        /*设备下拉路径*/
        devices() {
            return [
                {
                    icon: "iconfont icon-chongdianzhuang",
                    path: "/devices/pile",
                    text: "充电桩",
                },
                {
                    icon: "iconfont icon-chongdianqiang",
                    path: "/devices/gun",
                    text: "充电枪",
                },
            ];
        },
        /*优惠卷*/
        coupons() {
			if(this.role === 0) {
				return [
				    {
				        icon: "iconfont icon-youhuiquanmoban",
				        path: "/coupons/template",
				        text: "模板",
				    },
				    {
				        icon: "iconfont icon-youhuiquankong",
				        path: "/coupons/userCoupons",
				        text: "持有优惠券",
				    }
				];
			}else {
				return [
				    {
				        icon: "iconfont icon-youhuiquanmoban",
				        path: "/coupons/template",
				        text: "模板",
				    },
				    {
				        icon: "iconfont icon-youhuiquankong",
				        path: "/coupons/userCoupons",
				        text: "持有优惠券",
				    },
				    {
				        icon: "iconfont icon-huodong",
				        path: "/coupons/activity",
				        text: "活动",
				    },
				];
			}
        },
    },
};
</script>
